<template>
  <div>
    <!-- editNumInfo = !editNumInfo -->
    <a-button class="" v-show="!editNumInfo" type="primary" @click="edit">
      <!-- <a-icon type="form" /> -->
      编辑
    </a-button>
    <a-button class="" v-show="editNumInfo" type="primary" @click="saveHandle"
      ><!-- type="primary"  -->
      <!-- <a-icon type="check" /> -->
      提交
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editNumInfo: false,
      iconLoading: false,
    }
  },
  props: {
    load: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    load: {
      handler() {
        this.iconLoading = this.load
        this.editNumInfo = this.load
      },
      immediate: true,
    },
  },
  methods: {
    saveHandle() {
      this.$emit('saveHandle')
    },
    edit() {
      this.iconLoading = true
      this.editNumInfo = !this.editNumInfo
      this.$emit('edit', this.editNumInfo)
    },
  },
}
</script>
